// Si la app le está hablando a un backend que NO es producción.
//
// Existe por un error que llegó a la tienda: el panel de QA se mostraba cuando
// `location.hostname` era `localhost`, y el WebView de la app nativa sirve desde
// `https://localhost` **siempre**, también en la versión publicada. O sea que el
// host no distingue la app de prueba de la real; lo que sí las distingue es a
// qué backend le pegan.

/** Los backends que no son producción. Cualquier otro se considera producción. */
const BACKENDS_DE_PRUEBA = [
    "localhost",
    "127.0.0.1",
    "testing.crecientefertil.com.ar",
    "test.crecientefertil.com.ar",
];

/**
 * @param {string} urlBackend el valor de `VITE_RUTA_JAVA_SERVER`
 * @returns {boolean} si es un entorno de prueba
 */
export function esBackendDePrueba(urlBackend) {
    if (typeof urlBackend !== "string" || urlBackend === "") return false;
    return BACKENDS_DE_PRUEBA.some((host) => urlBackend.includes(host));
}
